import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const poItemDeleteSlice = createApi({
    reducerPath: "poItemDelete",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        poItemDelete: builder.mutation({
            query: ({ id, data }) => ({ url: "/inventory/api/v1/poitem/update?id=" + id, method: "PATCH", body: data }),
        }),
    }),
});

export const { usePoItemDeleteMutation } = poItemDeleteSlice;
